const FailedIcon = () => {
    return (
        <svg id="Failed" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill={"red"}>
            <g>
                <path className="st1" d="M50,25c0,13.8-11.2,25-25,25C11.2,50,0,38.8,0,25S11.2,0,25,0C38.8,0,50,11.2,50,25z M25,3.1
		C12.9,3.1,3.1,12.9,3.1,25S12.9,46.9,25,46.9c12.1,0,21.9-9.8,21.9-21.9S37.1,3.1,25,3.1z M17.6,17.6c0.6-0.6,1.6-0.6,2.2,0
		l5.1,5.1l5.1-5.1c0.6-0.6,1.6-0.6,2.2,0c0.6,0.6,0.6,1.6,0,2.2L27.2,25l5.1,5.1c0.6,0.6,0.6,1.6,0,2.2c-0.6,0.6-1.6,0.6-2.2,0
		L25,27.2l-5.1,5.1c-0.6,0.6-1.6,0.6-2.2,0c-0.6-0.6-0.6-1.6,0-2.2l5.1-5.1l-5.1-5.1C17,19.2,17,18.3,17.6,17.6z"/>
            </g>
        </svg>
    );
}
export default FailedIcon;
